import { render } from "./InsightView.vue?vue&type=template&id=76fb8e6c&scoped=true"
import script from "./InsightView.vue?vue&type=script&lang=js"
export * from "./InsightView.vue?vue&type=script&lang=js"

import "./InsightView.vue?vue&type=style&index=0&id=76fb8e6c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76fb8e6c"]])

export default __exports__